import styled from "styled-components";

const GROUP_CART_FOOTER_HEIGHT = "88px";

export const HostContainer = styled.div(({ theme }) => {
    return {
        position: "fixed",
        background: theme.colors[theme.colorMode].background_Primary,
        left: 0,
        bottom: 0,
        width: "100%",
        boxShadow: "0px -3px 20px 0px rgba(0, 0, 0, 0.08)",
        borderRadius: `${theme.spacing.large} ${theme.spacing.large} 0 0`,
        padding: theme.spacing.medium,
        paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.medium})`,
        height: `calc(var(--sab, 0px) + ${GROUP_CART_FOOTER_HEIGHT})`,
        "@supports (-webkit-touch-callout: none)": {
            "@supports (padding-bottom: env(safe-area-inset-bottom))": {
                paddingBottom: `calc(${theme.spacing.medium} + (env(safe-area-inset-bottom) / 2))`,
            },
        },
    };
});

export const GuestContainer = styled.div(({ theme }) => {
    return {
        paddingTop: theme.spacing.xxLarge,
        paddingLeft: theme.spacing.medium,
        paddingBottom: `var(--sab, 0px)`,
        "@supports (-webkit-touch-callout: none)": {
            "@supports (padding-bottom: env(safe-area-inset-bottom))": {
                paddingBottom: `calc(${theme.spacing.xxLarge} + (env(safe-area-inset-bottom) / 2))`,
            },
        },
    };
});

export const TextContainer = styled.div(({ theme }) => {
    return {
        marginTop: theme.spacing.xxSmall,
    };
});
